import { render, staticRenderFns } from "./MoleculeUniverseOrientationBar.vue?vue&type=template&id=5f51a355&"
import script from "./MoleculeUniverseOrientationBar.vue?vue&type=script&lang=js&"
export * from "./MoleculeUniverseOrientationBar.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeUniverseOrientationBar.vue?vue&type=style&index=0&id=5f51a355&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/MoleculeUniverseOrientationBar.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fmolecules%2FMoleculeUniverseOrientationBar.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomLocaleSwitch: require('/app/components/atoms/common/AtomLocaleSwitch.vue').default,AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default})
